import classnames from 'classnames';
import React, { FunctionComponent, PropsWithChildren, useEffect, useRef, useState } from 'react';

import styles from './_TabItem.module.css';

interface TabItemProps {
    className?: string;
    selected?: boolean;
    round?: boolean;
    autoFocus?: boolean;

    id?: string;
    label?: string;
    setWidth?: (width: number, id: string) => void;
    onClick?: () => void;
}

export const TabItem: FunctionComponent<PropsWithChildren<TabItemProps>> = (props) => {
    const {
        children,
        selected,
        className,
        label,
        onClick,
        setWidth,
        id = 'none',
        autoFocus,
        round,
    } = props;

    const itemRef = useRef<HTMLButtonElement | null>(null);
    const [itemWidth, setItemWidth] = useState(0);

    // eslint-disable-next-line react-hooks/exhaustive-deps
    useEffect(() => {
        if (itemRef.current) {
            const width = itemRef.current.offsetWidth;

            if (itemWidth !== width) {
                setItemWidth(width);
            }
        }
    });

    useEffect(() => {
        setWidth?.(itemWidth, id);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [itemWidth, id]);

    useEffect(() => {
        if (!autoFocus) {
            return;
        }

        itemRef.current?.focus();
    }, [autoFocus]);

    return (
        // https://www.scottohara.me/blog/2019/01/12/lists-and-safari.html
        // eslint-disable-next-line jsx-a11y/no-redundant-roles
        <li className={styles.item} role="listitem">
            <button
                ref={itemRef}
                className={classnames(
                    styles.button,
                    { [styles.button_selected]: selected },
                    { [styles.button_round]: round },
                    className
                )}
                aria-current={selected ? 'true' : undefined}
                aria-label={label}
                onClick={onClick}
            >
                {children}
            </button>
        </li>
    );
};
